<!--
================================================
Vue pour les page d'erreur 404 not found
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">


            <div class="columns">
                <div class="column"></div>

                <div class="column is-three-quarters">
                    <div class="statusCode">
                        404
                    </div>
                    <div class="errorMessage">
                        <b>{{$t('erreur404')}}</b> <br>
                        {{$t('laPageEstIntrouvable')}}

                        <br>
<!--                        <a id="goBackLink" @click="$router.go(-1)">{{$t('retour')}}</a>-->
                      <router-link v-bind:to="{name:'login',params:{'locale':'fr'}}" id="goBackLink">{{$t('retour')}}</router-link>

                    </div>
                </div>
                <div class="column"></div>
            </div>
            <!--<component></component>-->

        </div>
    </outdoor-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from "../components/OutdoorLayoutComp";
    // import Component from '@/components/Component.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";

    export default {
        name: 'NotFoundView',
        components: {
            OutdoorLayoutComp,
            // Component,
        },
        data: function () {
            return {
            }
        },
        mixins: [VueMetaMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleDefault"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {},
      created: function () {

        //Si la locale existe dans l'url on l'utilise pour traduire la vue (sinon utilisera la fallback locale)
        if (window.location.pathname.replace(/^\/([^/]*).*$/, '$1') == "") {
          this.$i18n.locale = "en"
        } else {
          this.$i18n.locale = window.location.pathname.replace(/^\/([^/]*).*$/, '$1') // ⚠️ récupère exceptionnellement la locale dans l'url (car pas dispo dans le routing). à voir si posera problème pour les app hybrides
        }
      },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";

    .statusCode{
        color: #eee;
        text-shadow: 0px 10px 0px darken($brandThird,10%);
        font-size:7rem;
    }
    .errorMessage{
        color: #eee;

        a{
            color: $brandPrimary
        }
    }
.column {

    /*background: red;*/
}

</style>
